export const createElement = (elementName, className, elementText = "") => {
    const child = document.createElement(elementName)
    child.classList.add(className)
    child.innerText = elementText
    return child
}


// WEBPACK FOOTER //
// ./javascript/product-search-page/utils/elementUtils.js